module.exports = __webpack_public_path__ + "img/6e20d4e2294e579e0b01ac7d0a12b465.svg";